const TOKENS = /(?:\d+(?:\.\d+)?)|[()+\-*/%]/g;

function precedence(operator: string): number {
  return operator === "+" || operator === "-" ? 1 : 2;
}

export function calculateExpression(expression: string): number {
  const compact = expression.replace(/\s/g, "");
  const tokens = compact.match(TOKENS) || [];
  if (!compact || tokens.join("") !== compact) throw new Error("表达式中含有不支持的字符");
  const output: string[] = [];
  const operators: string[] = [];
  let previous = "operator";

  tokens.forEach((token) => {
    if (/^\d/.test(token)) {
      output.push(token);
      previous = "number";
      return;
    }
    if (token === "(") {
      operators.push(token);
      previous = "operator";
      return;
    }
    if (token === ")") {
      while (operators.length && operators.at(-1) !== "(") output.push(operators.pop()!);
      if (operators.pop() !== "(") throw new Error("括号不匹配");
      previous = "number";
      return;
    }
    if (previous === "operator" && token === "-") output.push("0");
    while (operators.length && operators.at(-1) !== "(" && precedence(operators.at(-1)!) >= precedence(token)) {
      output.push(operators.pop()!);
    }
    operators.push(token);
    previous = "operator";
  });
  while (operators.length) {
    const operator = operators.pop()!;
    if (operator === "(") throw new Error("括号不匹配");
    output.push(operator);
  }

  const stack: number[] = [];
  output.forEach((token) => {
    if (/^\d/.test(token)) return void stack.push(Number(token));
    const right = stack.pop();
    const left = stack.pop();
    if (left === undefined || right === undefined) throw new Error("表达式不完整");
    if ((token === "/" || token === "%") && right === 0) throw new Error("不能除以零");
    const result = token === "+" ? left + right
      : token === "-" ? left - right
        : token === "*" ? left * right
          : token === "/" ? left / right
            : left % right;
    stack.push(result);
  });
  if (stack.length !== 1 || !Number.isFinite(stack[0])) throw new Error("无法计算该表达式");
  return stack[0];
}
